import React from 'react';
import { MehrstufigerWorkflow } from '../inhalte/MehrstufigerWorkflow';
import { BLOG_WORKFLOWS } from '../inhalte/workflowVarianten';

const BlogWorkflowPage: React.FC = () => <MehrstufigerWorkflow config={BLOG_WORKFLOWS} />;

export default BlogWorkflowPage;
